import React from "react";
import { useRecoilValue } from "recoil";
import { getRecoil, setRecoil } from "recoil-nexus";
import styled from "styled-components";
import ApiController from "../../../controller/ApiController";
import LogController from "../../../controller/LogController";
import { EventType } from "../../../controller/MasterController";
import { authState } from "../../../recoil/auth";
import { eventState } from "../../../recoil/event";
import { langState, langText } from "../../../recoil/lang";

interface CustomEventSliderProps {
  title: string;
  type: string;
  color: string;
  imagePath: string;
}

const CustomEventSlider = ({
  title,
  type,
  color,
  imagePath,
}: CustomEventSliderProps) => {
  const lang = useRecoilValue<number>(langState);

  // API 이벤트리스트 불러오기
  const getEventList = async () => {
    const user_id = getRecoil(authState).user_id;
    const user_token_id = getRecoil(authState).user_token_id;

    try {
      const response = await ApiController.store.getEventList(
        user_id,
        user_token_id
      );

      if (response && response.data) {
        const oRes = response.data;
        const eventItem = oRes.data.find(
          (item: EventType) => item.event_name === type
        );
        if (eventItem) {
          LogController.click({
            path: "StoreSelector(MainPage)",
            params: "event",
            params2: `${type} 슬라이더 클릭`,
            index: eventItem.event_id,
          });

          setRecoil(eventState, {
            ...eventItem,
            visible: true,
            coupon: null,
          });
        }
      }
    } catch (err) {
      console.log("getAdverList err-->", err);
    }
  };

  return (
    <Style>
      <div
        className="slideBadge"
        onClick={getEventList}
        style={{ backgroundColor: color }}
      >
        <div className="row gap">
          <img src={imagePath} alt="event" />
          <h3>EVENT</h3>
        </div>
        <div className="row between">
          <h3>{title}</h3>
          {/* <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_slide_coupon.svg`}
            alt="coupon"
          /> */}
          {/* <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_arrow_right.svg`}
            alt="open"
          /> */}
          <div className="badge">
            <h5>{langText.slider_join[lang]}</h5>
          </div>
        </div>
      </div>
    </Style>
  );
};
export default CustomEventSlider;

const Style = styled.div`
  .slideBadge {
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 5%;
    padding: 10px 18px 10px 30px;

    .row.gap {
      gap: 14px;
    }
    .row.between {
      width: 100%;
      justify-content: space-between;
    }
    h3 {
      padding-top: 4px;
      font-size: 18px;
      line-height: 26px;
      font-weight: 400;
      color: #fff;
      font-family: "Jalnan2TTF";
    }
    .badge {
      border-radius: 7px;
      border: 2px solid #fff;
      padding: 6px 20px;
      h5 {
        font-size: 14px;
        line-height: 20px;
        font-family: "Jalnan2TTF";
        white-space: nowrap;
      }
    }
  }
`;
